import { useEffect, useState } from 'react';
import api from '../../../../../api';
import AOS from 'aos';
import 'aos/dist/aos.css';

const French = () => {

  const [frenchSection, setFrenchSection] = useState({});
 const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const AOS = require('aos');
            AOS.init({
                duration: 1000,
                once: true
            });
        }
    }, []);


  useEffect(() => {
    const fetchCarouselData = async () => {
      try {
        const response = await api.get('/api/pages/center');
        const groupData = response.data.groups;
        const french_section = groupData[2].french_section;

         setFrenchSection(french_section);
       
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchCarouselData();
  }, []);



  return (
    <section className="mb-3 mb-md-5">
      <div className="container bg-french">
        <div className="row ">
          <h2
            className="sec-title text-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
           {frenchSection.heading}
          </h2>
        </div>
        <div className="row" data-aos="fade-up" data-aos-duration="1000">
          <div className="col-md-6">
            <p style={{ textAlign: 'justify' }} className="p-3">
               {frenchSection.content}
            </p>
          </div>
          <div className="col-md-6">
            <img
              src={frenchSection.image}
              alt="Why Learn French"
              className="img-fluid" style={{ borderRadius: "10px" }}

            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default French;